/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Sign16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray40}
            d="M15.5 15a.5.5 0 110 1H.5a.5.5 0 110-1h15zM6 0c1.936 0 3.191 2.265 2.996 4.584-.138 1.652-1.277 3.625-2.87 5.267l-.11.111.078.123c.36.54.794.863 1.283.91L7.5 11c.393 0 .73-.251 1.179-.887l.197-.295.35-.544.154-.226.143-.193C9.94 8.32 10.381 8 11 8c.674 0 1.138.39 1.468.983.076.138.139.266.202.422l.1.258.319.93.071.192.081.185.11-.03c.243-.08.508-.245.796-.507l.146-.14a1 1 0 011.414 1.414C14.867 12.547 13.961 13 13 13c-.674 0-1.138-.39-1.468-.983a3.822 3.822 0 01-.202-.422l-.1-.258-.332-.965-.44.683C9.613 12.32 8.781 13 7.5 13c-1.252 0-2.23-.576-2.949-1.558l-.09-.127-.057.043c-.916.674-1.9 1.21-2.884 1.529l-.245.075a1 1 0 11-.55-1.924c.92-.263 1.867-.797 2.737-1.475l.128-.103-.032-.1c-.359-1.175-.541-2.568-.557-4.079L3 4.997C3.009 2.197 4.053 0 6 0zm0 2c-.437 0-.994 1.173-1 3.003-.003.963.073 1.854.217 2.638l.038.196.165-.197c.84-1.038 1.427-2.136 1.563-3.045l.02-.179C7.114 3.111 6.498 2 6 2zm5 3a1 1 0 110 2 1 1 0 010-2z"
        />
    </AccessibleSVG>
);

export default Sign16;
